<mat-toolbar color="primary">
  Cassette Images
</mat-toolbar>

<div class="table-container">
  <table mat-table [dataSource]="imageResults" class="image-table" matSort>

    <!-- Delay Column -->
    <ng-container matColumnDef="delay">
      <th mat-header-cell *matHeaderCellDef> Delay </th>
      <td mat-cell *matCellDef="let row"> {{ row.delay }} ms </td>
    </ng-container>

    <!-- Dark Image Column -->
    <ng-container matColumnDef="dark">
      <th mat-header-cell *matHeaderCellDef> Dark </th>
      <td mat-cell *matCellDef="let row">
        <img *ngIf="row.dark" [src]="row.dark" alt="Dark image" />
      </td>
    </ng-container>

    <!-- Light Image Column -->
    <ng-container matColumnDef="light">
      <th mat-header-cell *matHeaderCellDef> Light </th>
      <td mat-cell *matCellDef="let row">
        <img *ngIf="row.light" [src]="row.light" alt="Light image" />
      </td>
    </ng-container>

    <!-- CC Image Column -->
    <ng-container matColumnDef="cc">
      <th mat-header-cell *matHeaderCellDef> CC </th>
      <td mat-cell *matCellDef="let row">
        <img *ngIf="row.cc" [src]="row.cc" alt="CC image" />
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="['delay', 'dark', 'light', 'cc']"></tr>
    <tr mat-row *matRowDef="let row; columns: ['delay', 'dark', 'light', 'cc'];"></tr>
  </table>
</div>

<div class="actions">
  <button mat-raised-button color="accent" (click)="close()">Close</button>
</div>
